var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_width_box"},[_c('div',{staticClass:"content_title"},[_c('div',{staticClass:"title_left_h2"},[_vm._v(_vm._s(_vm.$t('investor.businessFile.title')))])]),_c('FileTitleListView',{attrs:{"messageList":_vm.businessFileList.list,"perPage":_vm.businessFileList.perPage,"detailRouter":"invstorDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }